import React, { useCallback, useEffect, useState } from "react";
import axios from "../../API/axios";
import { post, people } from "../../config/imagesLink";
import { Link } from "react-router-dom";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from "react-i18next";
import { ShimmerDiv } from "@skeleton";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";

const LikesDetails = ({
  showModal,
  handleLikesCloseModal,
  postId,
  showCommentLikeModal,
  handleCommentLikeCloseModal,
  postCommentId,
  showCommentReplyLikeModal,
  handleCommentReplyLikeCloseModal,
  postCommentReplyId,
}) => {

  const language = localStorage.getItem("Lang");
  const [postIdLikeData, setPostIdLikeData] = useState([]);
  const [likeLoading, setLikeLoading] = useState(false);
  const [commentlikeLoading, setCommentLikeLoading] = useState(false);
  const [commentReplyLikeLoading, setCommentReplyLikeLoading] = useState(false);
  const [commentLikeData, setCommentLikeData] = useState([]);
  const { t } = useTranslation();

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  // console.log("postCommentReplyId", postCommentReplyId);
  //   Get post Like Response
  const GetPostsLikes = async () => {
    setLikeLoading(true);
    // console.log("soheb");
    try {
      await axios
        .get(`Posts/GetPostLikes?DeviceType=Web&PostId=${postId}&langKey=${language}`)
        .then((res) => {
          // console.log("postIdLikeData7777", res);
          if (res.status === 200) {
            // console.log("postIdLikeData7777", res.data.responseData);
            setPostIdLikeData(res.data.responseData);
            setLikeLoading(false);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (showModal) {
      GetPostsLikes();
    }
  }, [postId, showModal]);

  //   Get comment like response
  const GetCommentsLikes = async () => {
    // console.log("comment res");
    setCommentLikeLoading(true);
    try {
      await axios
        .get(
          `Posts/GetPostCommentsLikes?DeviceType=Web&PstCmntId=${postCommentId}&langKey=${language}`
        )
        .then((res) => {
          // console.log("comments res====>", res.data.responseData);
          setCommentLikeData(res.data.responseData);
          setCommentLikeLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (showCommentLikeModal) {
      GetCommentsLikes();
    }
  }, [postCommentId]);

  //   Get comment reply response
  const [commentReplyLikeData, setCommentReplyLikeData] = useState([]);
  const GetCommentsReplyLikes = async () => {
    setCommentReplyLikeLoading(true);
    try {
      await axios
        .get(
          `Posts/GetCommentRepliesLikes?DeviceType=Web&PstCmntRplyId=${postCommentReplyId}&langKey=${language}`
        )
        .then((res) => {
          setCommentReplyLikeData(res.data.responseData);
          setCommentReplyLikeLoading(false);
        });
    } catch (error) {
      console.log(error);
          setCommentReplyLikeLoading(false);

    }
  };
  useEffect(() => {
    if (showCommentReplyLikeModal) {
      GetCommentsReplyLikes();
    }
  }, [postCommentReplyId]);

  // console.log("postIdLikeData7777", postIdLikeData);
  // console.log("postLikedType", postLikedType);

  useEffect(() => {
    if (showModal || showCommentLikeModal || showCommentReplyLikeModal) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      // NOT adding 'modal-open' because it has position: fixed which causes the page to jump to the top
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [showModal, showCommentLikeModal, showCommentReplyLikeModal]);

  const handleEscapeClose = useCallback(() => {
    if (showCommentReplyLikeModal) {
      handleCommentReplyLikeCloseModal?.();
    } else if (showCommentLikeModal) {
      handleCommentLikeCloseModal?.();
    } else if (showModal) {
      handleLikesCloseModal?.();
    }
  }, [
    showModal,
    showCommentLikeModal,
    showCommentReplyLikeModal,
    handleLikesCloseModal,
    handleCommentLikeCloseModal,
    handleCommentReplyLikeCloseModal,
  ]);

  useEscapeKeyDown(
    showModal || showCommentLikeModal || showCommentReplyLikeModal,
    handleEscapeClose
  );

  return (
    <>
      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2 pb-4">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("Newsfeed.Reactions")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleLikesCloseModal();
                  }}
                />
              </div>

              <div className="reaction-cont">

                {likeLoading ? (
                  <div className="mt-3">
                    <>
                      <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                      <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                      <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                    </>
                  </div>
                ) :
                  postIdLikeData &&
                  postIdLikeData.map((item) => {
                    console.log("bvnbcxvznbc", item);
                    return (
                      <div className="post-like-details-cont p-1  ">
                        <div className="like-header-cont d-flex justify-content-between align-items-center pe-2 ps-2">

                          <Link to={`/User/${item.useruid}`}>
                            <div className="like-header-cont d-flex align-items-center gap-2">
                              <div className="like-image-cont flex-shrink-0">
                                <img
                                  src={item.userAvatar || people.DefaultProfile}
                                  alt=""
                                  width={50}
                                  height={50}
                                  onError={handleProfileImageError}
                                />
                              </div>

                              <div>
                                <div className="liked-user-name f-700 f-14">
                                  {item.userName}
                                </div>
                              </div>
                            </div>

                          </Link>

                          <div className="like-selected-imoji mt-2 ms-2">
                            <div className="like-container pointer d-flex align-items-center">
                              {item?.likeType === 1 ? (
                                <>
                                  <div className="liked-imoji">
                                    <img src={post.LikeGif} width={30} />
                                  </div>
                                </>
                              ) : item?.likeType === 2 ? (
                                <>
                                  <div className="liked-imoji">
                                    <img src={post.LoveGif} width={30} />
                                  </div>
                                </>
                              ) : item?.likeType === 3 ? (
                                <>
                                  <div className="liked-imoji">
                                    <img src={post.LaughingGif} width={30} />
                                  </div>
                                </>
                              ) : item?.likeType === 4 ? (
                                <>
                                  <div className="liked-imoji">
                                    <img src={post.WowGif} width={30} />
                                  </div>
                                </>
                              ) : item?.likeType === 5 ? (
                                <>
                                  <div className="liked-imoji">
                                    <img src={post.AngryGif} width={30} />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="liked-imoji">
                                    <img src={post.LikeGif} width={30} />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div>
      )}

      {showCommentLikeModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2 pb-4">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Newsfeed.Comment Reactions")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCommentLikeCloseModal();
                  }}
                />
              </div>
              <div className="reaction-cont">
                {
                  commentlikeLoading ? (
                    <div className="mt-3">
                      <>
                        <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                        <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                        <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                      </>
                    </div>
                  ) :
                    commentLikeData.map((item) => {
                      return (
                        <div className="post-like-details-cont p-1">
                          <div className="like-header-cont d-flex justify-content-between align-items-center pe-2 ps-2">
                            <Link to={`/User/${item.useruid}`}>
                              <div className="d-flex align-items-center gap-2">
                                <div className="like-image-cont flex-shrink-0">
                                  <img
                                    src={item.userAvatar || people.DefaultProfile}
                                    alt=""
                                    onError={handleProfileImageError}
                                  />
                                </div>

                                <div>
                                  <div className="liked-user-name f-700 f-14 ">
                                    {item.userName}
                                  </div>
                                </div>
                              </div>
                            </Link>
                            <div className="like-selected-imoji">
                              <div className="like-container pointer d-flex align-items-center">
                                {item?.likeType === 1 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LikeGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 2 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LoveGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 3 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LaughingGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 4 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.WowGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 5 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.AngryGif} width={30} />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LikeGif} width={30} />
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </div>
      )}

      {showCommentReplyLikeModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2 pb-4">
              <div className="modalBorder d-flex justify-content-between align-items-center pe-2 ps-2">
                <h6>{t("Newsfeed.Comment Reply Reactions")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCommentReplyLikeCloseModal();
                  }}
                />
              </div>
              <div className="reaction-cont">
                {
                  commentReplyLikeLoading ? (
                    <div className="mt-3">
                      <>
                        <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                        <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                        <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                      </>
                    </div>
                  ) :
                    commentReplyLikeData.map((item) => {
                      return (
                        <div className="post-like-details-cont p-1">
                          <div className="like-header-cont d-flex justify-content-between align-items-center pe-2 ps-2">
                            <Link to={`/User/${item.useruid}`}>
                              <div className="d-flex align-items-center gap-2">
                                <div className="like-image-cont flex-shrink-0">
                                  <img
                                    src={item.userAvatar || people.DefaultProfile}
                                    alt=""
                                    onError={handleProfileImageError}
                                  />
                                </div>

                                <div>
                                  <div className="liked-user-name f-700 f-14">
                                    {item.userName}
                                  </div>
                                </div>
                              </div>
                            </Link>
                            <div className="like-selected-imoji">
                              <div className="like-container pointer d-flex align-items-center">
                                {item?.likeType === 1 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LikeGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 2 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LoveGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 3 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LaughingGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 4 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.WowGif} width={30} />
                                    </div>
                                  </>
                                ) : item?.likeType === 5 ? (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.AngryGif} width={30} />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="liked-imoji">
                                      <img src={post.LikeGif} width={30} />
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LikesDetails;
